// Função utilitária para recortar imagem a partir do canvas
export default function getCroppedImg(imageSrc, pixelCrop) {
  return new Promise((resolve, reject) => {
    const image = new window.Image();
    image.crossOrigin = 'anonymous';
    image.src = imageSrc;
    image.onload = () => {
      // Bloqueia imagens muito grandes (ex: acima de 8MB no base64)
      try {
        // Estima tamanho do base64 em bytes
        const base64Length = imageSrc.length - (imageSrc.indexOf(',') + 1);
        const padding = (imageSrc.charAt(imageSrc.length - 2) === '=') ? 2 : (imageSrc.charAt(imageSrc.length - 1) === '=') ? 1 : 0;
        const fileSize = base64Length * 0.75 - padding;
        if (fileSize > 8 * 1024 * 1024) {
          reject(new Error('Imagem muito grande. Escolha uma foto menor que 8MB.'));
          return;
        }
      } catch (e) { /* fallback: nunca bloqueia se não conseguir estimar */ }
      const canvas = document.createElement('canvas');
      canvas.width = pixelCrop.width;
      canvas.height = pixelCrop.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height
      );
      // Função auxiliar para tentar compressão progressiva
      const tryCompress = (quality) => {
        canvas.toBlob((blob) => {
          if (!blob) {
            reject(new Error('Canvas está vazio'));
            return;
          }
          if (blob.size > 2 * 1024 * 1024 && quality > 0.4) {
            // Se ainda está grande, reduz mais a qualidade
            tryCompress(quality - 0.15);
          } else {
            blob.name = 'cropped.jpeg';
            resolve(blob);
          }
        }, 'image/jpeg', quality);
      };
      tryCompress(0.7); // começa com qualidade 0.7
    };
    image.onerror = () => reject(new Error('Erro ao carregar imagem'));
  });
}
